export enum GateTypes {
  LOADING = 'loading',
  COUNTRY_BLOCKED = 'countryBlocked',
  AGE_BLOCKED = 'ageBlocked',
  AGE_GATE = 'ageGate',
  PRIVACY_POLICY = 'privacyPolicy',
  EXCLUSIVE_CONTENT = 'exclusiveContent',
}
